import { useQuery } from 'react-query'
import { api } from '../../api'
import { localConfig } from '../../../Configs/localConfig'
import { errorAlert } from '../../../utils/alert'

type Item = {
  cod: number
  nome: string
  descricao: null
}

interface CadastroCargos {
  itens: Item[]
  total: number
}

export const useGetCargos = (pagination = 15, page = 1, nome?: string) => {
  const queryKey: any = [`/adm/cargo`]

  const { data, isFetching, refetch, isFetchedAfterMount, isError } = useQuery<
    CadastroCargos,
    Error
  >(
    queryKey,
    async () => {
      const paramNome = nome ? `&nome=${nome}` : ''
      return api
        .get(
          `/adm/cargo?codConta=${localConfig()?.conta}&codCliente=${
            localConfig()?.codCliente
          }&pagination=${pagination}&page=${page}${paramNome}`
        )
        .then((response): any => {
          return response.data
        })
        .catch((error) => {
          errorAlert(error?.response?.data?.error ?? 'Falha ao obter lista de cargos!')
        })
    },
    {
      enabled: false,
      refetchOnWindowFocus: false,
    }
  )

  return {
    data_cargos: data,
    carregando_cargos: isFetching,
    refetch_data_cargos: refetch,
    isFetched: isFetchedAfterMount,
    isError: isError,
  }
}

export const useGetEditarCargos = (cod: number) => {
  const queryKey: any = [`/adm/cargo_${cod}`]

  const { data, isFetching, refetch, isFetchedAfterMount, isError } = useQuery<
    CadastroCargos,
    Error
  >(
    queryKey,
    async () => {
      return api
        .get(
          `/adm/cargo?codConta=${localConfig()?.conta}&codCliente=${
            localConfig()?.codCliente
          }&pagination=-1&cod=${cod}`
        )
        .then((response): any => {
          return response.data
        })
        .catch((error) => {
          errorAlert(error?.response?.data?.error ?? 'Falha ao obter lista de cargos!')
        })
    },
    {
      enabled: false,
      refetchOnWindowFocus: false,
    }
  )

  return {
    data_cargos_editar: data,
    carregando_cargos_editar: isFetching,
    refetch_data_cargos_editar: refetch,
    isFetched: isFetchedAfterMount,
    isError: isError,
  }
}
